import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../dynamicFormBuilder/FormField'
import { AdditionalLayout } from '../Layout';
function AdditionalTab(props) {
    var accessToken = props.oidc.user.access_token;
        const formRefs = useRef({});
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    var currentUser = props.oidc.user;
    const handleFieldChangeDimensions = useCallback((name, value, e) => {
        props.handleFieldChange(name, value, e, formRefs);
    }, []);
    const handleDimensionFormLoad = useCallback(() => {
    }, []);
    return (
        <>
            <div>
                <FormField
                    currrentUser={currentUser}
                    layoutId='B7FF9A27-BE12-4041-816F-3EF0ECF90B62'
                    layoutName='AdditionalLayout'
                    defaultFormSchema={AdditionalLayout}
                    formFields={props.formFields}
                    setformFields={props.setformFields}
                    handleFieldValueChange={handleFieldChangeDimensions}
                    DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                    formRefs={formRefs}
                    onFormLoad={handleDimensionFormLoad}
                    handleSelectedItemChange={handleFieldChangeDimensions}
                />
            </div>
        </>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(AdditionalTab);